export default "__VITE_ASSET__8rXicK7U__"